import { render, staticRenderFns } from "./SafetyAlertBlock.vue?vue&type=template&id=b9796270&scoped=true&"
import script from "./SafetyAlertBlock.vue?vue&type=script&lang=js&"
export * from "./SafetyAlertBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9796270",
  null
  
)

export default component.exports